import { GridColumnProps } from "@progress/kendo-react-grid";
import i18n from "i18n";
import { GrideDateFormatter } from "ui/Date";

export const DocumentsGridColumnItem = (): GridColumnProps[] => [
	{
		field: "fileName",
		title: i18n.t("Name"),
		headerClassName: "no-border",
	},
	{
		field: "description",
		title: i18n.t("Description"),
		headerClassName: "no-border",
	},
	{
		field: "contentType",
		title: i18n.t("AttachmentContentType"),
		headerClassName: "no-border",
	},

	{
		field: "timeCreated",
		title: i18n.t("AttachmentUploaded"),
		headerClassName: "no-border",
		cells: {
			data: (props) => (
				<GrideDateFormatter
					date={props.dataItem.timeCreated}
					formatType={"dd.MM.yyyy"}
				/>
			),
		},
	},
	{
		field: "createdByUsername",
		title: i18n.t("Username"),
		headerClassName: "no-border",
	},
];
